import React from "react";

function IcArrow() {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m5.836 5.766 3.422-4.068c.158-.187.242-.377.242-.534 0-.304-.3-.492-.802-.492H1.3C.799.672.5.86.5 1.163c0 .158.084.344.242.532l3.423 4.07c.22.262.517.407.835.407.319 0 .615-.144.836-.406Z"
        fill="#1062D0"
      />
    </svg>
  );
}

export default IcArrow;
